"use client";

import { createContext, use } from "react";

export interface AIChatInputFileContextValue {
  accept?: string[];
  maxSize: number;
  /** Validates files against accept/maxSize, then forwards to addFiles. */
  handleFiles: (files: File[]) => void;
}

export const AIChatInputFileContext =
  createContext<AIChatInputFileContextValue | null>(null);

export function useAIChatInputFileContext(): AIChatInputFileContextValue {
  const ctx = use(AIChatInputFileContext);
  if (!ctx) {
    throw new Error(
      "File-handling compound components (e.g. AIChat.Input.FileUpload) must be used within an AIChat.Input.DropZone.",
    );
  }
  return ctx;
}
